

























import { defineComponent, computed } from '@vue/composition-api';
import SearchDeliveryTypeSwitch from '../search-delivery-type-switch/index.vue';
import PlacementTTImage from '@tt4b/ttam-assets/src/images/placement/placement-tt.png';

const name = 'ttam-placement-type-tiktok-item';

export default defineComponent({
  name,
  components: {
    SearchDeliveryTypeSwitch,
  },
  props: {
    searchDeliveryType: {
      type: Number,
      default: 0,
    },
    searchDeliveryTypeDisabled: {
      type: Boolean,
      defalut: false,
    },
    searchDeliveryTypeVisible: {
      type: Boolean,
      defalut: false,
    },
  },
  setup(props, { emit }) {
    const _searchDeliveryType = computed({
      get: () => props.searchDeliveryType || 0,
      set: val => emit('search-delivery-type-change', val),
    });

    const onSearchDeliverlyTypeChange = v => {
      _searchDeliveryType.value = v;
    };

    return {
      name,
      PlacementTTImage,
      _searchDeliveryType,
      onSearchDeliverlyTypeChange,
    };
  },
});
